module.exports = __webpack_public_path__ + "static/assets/25eac09980011373fca550b4f97acc07.png";